import type { AnalyticSession } from "@octopusdeploy/portal-analytics";
import * as React from "react";
import { useLocation } from "react-router-dom";
import { session } from "~/clientInstance";
import { authRoutes } from "~/components/AuthenticationRoutes/authRoutes";
import InternalRedirect from "../Navigation/InternalRedirect/InternalRedirect";
import { createFromLocationState } from "./createFromLocationState";
interface SecureRouteProps {
    analyticsSession: AnalyticSession | undefined;
    children: React.ReactNode;
}
export default function SecureRoute({ analyticsSession, children }: SecureRouteProps) {
    const location = useLocation();
    const [isAuthenticated, setIsAuthenticated] = React.useState(session.isAuthenticated());
    React.useEffect(() => session.subscribe(() => {
        setIsAuthenticated(session.isAuthenticated());
    }), []);
    // Test for analyticsSession is for debug mode recompile relaunches, otherwise it causes the user to be authenticated (session is a global statid), but the session to not be started (analyticsSession is in context)
    if (!isAuthenticated || analyticsSession === undefined) {
        return <InternalRedirect to={{ pathname: authRoutes.signIn, state: createFromLocationState(location) }}/>;
    }
    return <>{children}</>;
}
